import React, { useContext } from "react";

import styles from './HeaderHome.module.css';
import imgasesor from "../../img/userasesor.png";
import btndesplegar from "../../img/btndesplegar.png";
import pacificologo2 from "../../img/pacifico-logo-2.png";

import GeneralContext from "../../context/GeneralContext";
import * as GeneralActions from '../../store/actions/generalActions'
import { useAuth } from "../../context/AuthContext";

export const HeaderHome = ({ usuario }) => {
  const { dispatch: generalDispatch } = useContext(GeneralContext);
  const { logout } = useAuth();

  const handleLogout = () => {
    generalDispatch(GeneralActions.logout());
    logout();
  }

  return (
    <header className={styles['headsearch']}>
      <div>
          <img className={styles['logocian']} src={pacificologo2} alt='' />
      </div>
      <div
        className={`${styles['headsearch__asesor']} ${styles['dropdown']}`}>
        <div className={styles['headatosasesor']}>
            <span className={styles['textnameasesor']}>
              {usuario !== null && usuario !== undefined && usuario.info !== null && usuario.info !== undefined
                ? usuario.info.Nombres + ' ' + usuario.info.ApellidoPaterno + ' ' + usuario.info.ApellidoMaterno
                : null}
            </span>
            <span className={styles['texttopasesor']}>{usuario !== null && usuario !== undefined &&
              usuario.info !== null && usuario.info !== undefined ? usuario.info.EmailInterno : null}</span>
        </div>
        <img src={imgasesor} className={styles['imgasesor']} alt='' />
        <img src={btndesplegar} className={`${styles['btndesplegar']} ${styles['dropbtn']}`} alt='' />

        <div className={styles['dropdown-content']}>
          {/*<a href="/datosPersonales">Datos Personales</a>*/}
          <a href="/" onClick={handleLogout}>Cerrar sesión</a>
        </div>
      </div>
    </header>
  )
}

export default HeaderHome;